import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <>
      <div className="text-center py-20 lg:py-24 relative">
        <h1 className="text-4xl lg:text-6xl lg:tracking-[-6px] font-popinsBold text-themeColor">
          Terms <span className="text-btnColor">and</span> Conditions
        </h1>
        <p className="font-popinsMedium text-lg text-textColor w-[90%] lg:w-[45%] mx-auto leading-6 pt-4">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
        </p>
        <div className="flex flex-col md:flex-row md:justify-center w-[90%] md:w-[75%] lg:w-[55%] xl:w-[50%] 2xl:w-[40%] mx-auto mt-8">
          {/* <div className="md:w-[64%] relative w-full">
            <input
              type="text"
              placeholder="Enter You Email"
              className="pl-10 py-3 rounded-full w-full !border-2 !border-textColor/50"
            />
            <div className="absolute top-4 left-3">
              <Mail size={18} className="text-textColor/50" />
            </div>
          </div> */}
          <Link to={"/request-demo"} className="md:w-[35%] flex justify-center mt-5 md:mt-0">
            <button class="animated-button">
              <svg
                viewBox="0 0 24 24"
                class="arr-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
              </svg>
              <span class="text font-popinsSemiBold text-sm">
                Request a demo
              </span>
              <span class="circle"></span>
              <svg
                viewBox="0 0 24 24"
                class="arr-1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
              </svg>
            </button>
          </Link>
        </div>
        <div className="absolute left-0 bottom-10 size-56">
          <img
            src="/assets/hero.png"
            alt=""
            className="size-full object-fill"
          />
        </div>
      </div>
    </>
  );
};

export default Hero;
